import styled from 'styled-components';
import {
  whiteSphera,
  neutralBlue,
  neutralBlueGray,
  neutralLight,
  greenSp,
  brandBlack,
  grayLightSphera,
  neutralGray
} from 'src/utilities/UIStyles/variables/Colors';

export const Contracts = styled.div`
  width: 90%;
  margin: 0 auto;
  padding: 2.5% 2.5% 2.5% 5%;
  background-color: ${whiteSphera};
  border-radius: 5px;
  -webkit-box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  box-shadow: 1px 1px 10px 0px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-wrap: wrap;
  > div {
    width: 90%;
    margin: 2% 5%;
    display: flex;
    flex-wrap: wrap;
    > h3 {
      color: ${greenSp};
      width: 100%;
      text-align: center;
      font-size: 1.2vw;
    }
  }

  @media (min-width: 600px) and (max-width: 1024px) {
    > div {
      > h3 {
        font-size: 2vw;
      }
    }
  }

  @media (max-width: 600px) {
    > div {
      > h3 {
        font-size: 3.3vw;
      }
    }
  }
`;

export const EachContract = styled.div`
  margin: 5% 0;
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
  width: 50%;
  > p {
    color: ${brandBlack};
    font-size: 1.5vw;
    width: 90%;
    margin: 2% 0;
    text-align: center;
  }
  > p {
    width: 90%;
    text-align: center;
    > a {
      color: ${greenSp};
      text-decoration: none;
      font-weight: bold;
    }
  }
  > button {
    font-size: 1.2vw;
    font-weight: bold;
    color: ${whiteSphera};
    width: 35%;
    padding: 1%;
    border: none;
    border-radius: 5px;
    background-color: ${brandBlack};
    cursor: pointer;
  }
  @media (min-width: 600px) and (max-width: 1024px) {
    > p {
      font-size: 1.7vw;
    }
    > p {
      font-size: 1.7vw;

      > a {
        font-size: 1.7vw;
      }
    }
    > button {
      font-size: 1.6vw;
      width: 50%;
      padding: 1.5%;
    }
  }

  @media (max-width: 600px) {
    width: 100%;
    > p {
      font-size: 2.9vw;
    }
    > p {
      font-size: 2.9vw;

      > a {
        font-size: 2.9vw;
      }
    }
    > button {
      font-size: 2.6vw;
      font-weight: bold;
      color: ${whiteSphera};
      width: 50%;
      padding: 1.5%;
      border: none;
      border-radius: 5px;
      background-color: ${brandBlack};
      cursor: pointer;
    }
  }
`;
